import React, { useEffect, useState } from 'react';
import { partnersAPI } from '../../lib/api';
import { Label } from '../ui/label';

const TIPOS = { PAT: 'PAT', PREFEITURA: 'Prefeitura', SINE: 'SINE' };

export const PartnerOriginSelect = ({ value, onChange, dark = false }) => {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    partnersAPI.getPublicList().then((r) => setPartners(r.data || [])).catch(() => {});
  }, []);

  return (
    <div>
      <Label htmlFor="partner-origin" className={dark ? 'text-slate-300 text-sm' : ''}>Fui encaminhado por (PAT, Prefeitura ou SINE)</Label>
      <select
        id="partner-origin"
        value={value || ''}
        onChange={(e) => onChange(e.target.value || null)}
        className={`mt-1 w-full h-10 rounded-md border px-3 text-sm ${dark ? 'bg-slate-800 border-slate-700 text-white' : 'border-input bg-background'}`}
        data-testid="partner-origin-select"
      >
        <option value="">Nenhum (opcional)</option>
        {partners.map((p) => (
          <option key={p.id} value={p.id}>
            {p.nome} · {TIPOS[p.tipo] || p.tipo} · {p.municipio}/{p.estado}
          </option>
        ))}
      </select>
      <p className="text-xs text-slate-500 mt-1">A entidade acompanha seus encaminhamentos para vagas.</p>
    </div>
  );
};
